import script from "./CheckboxgroupCheckbox_tabs.vue?vue&type=script&lang=js"
export * from "./CheckboxgroupCheckbox_tabs.vue?vue&type=script&lang=js"

import "./CheckboxgroupCheckbox_tabs.vue?vue&type=style&index=0&id=e00b1abe&lang=scss"

const __exports__ = script;

export default __exports__